import type { AxiosInstance } from 'axios'

export const getCompanyDetail = (api: AxiosInstance) => (companyId: string) =>
  api.get(`/v1.0/admin/companies/${companyId}`)
